import {
  OrganizationAPI,
  OrganizationQuery,
  OrganizationItem,
  MpxResponseError,
  PaginationResponse,
} from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from './queryKey'

export const useOrganizations = (query?: OrganizationQuery) =>
  useQuery<PaginationResponse<OrganizationItem>, Error | MpxResponseError>(
    [QUERY_KEY.ORGANIZATIONS, JSON.stringify(query)],
    () => OrganizationAPI.list(query)
  )
